import React from 'react';
import CustomerEmailEdit from '../v3/checkout/subcomponents/CustomerEmailEdit';

const ParentChangeEmail = () => {
  return <CustomerEmailEdit onSuccessRoute="/my-account" />;
};

export default ParentChangeEmail;
